// extracted by mini-css-extract-plugin
module.exports = {"address":"styles_address__szSUf"};